import { render, staticRenderFns } from "./InodeIcon.vue?vue&type=template&id=4366b884&scoped=true&lang=pug"
import script from "./InodeIcon.vue?vue&type=script&lang=js"
export * from "./InodeIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4366b884",
  null
  
)

export default component.exports